import { StoreRemoveOutlineIcon } from './StoreRemoveOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 2EDD35EF-2F8B-4EA9-BED4-D211B29C0012
 * name store-remove-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-remove-outline.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const ShopDeleteOutlineIcon = StoreRemoveOutlineIcon;
export default ShopDeleteOutlineIcon